import { render, staticRenderFns } from "./BuildingModal.vue?vue&type=template&id=1961a85e&"
import script from "./BuildingModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1961a85e')) {
      api.createRecord('1961a85e', component.options)
    } else {
      api.reload('1961a85e', component.options)
    }
    module.hot.accept("./BuildingModal.vue?vue&type=template&id=1961a85e&", function () {
      api.rerender('1961a85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingModal.vue"
export default component.exports